"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("../computePrice");
/**
 * Initializes online order, sets status to CREATED
 * @param event of type InitiateOnlineOrderEvent
 * @param prevState
 */
function default_1(event, prevState = {}) {
    var _a;
    const partialOrder = event.order;
    let order = {
        ...prevState,
        id: event.orderId,
        organization: { id: event.organizationId },
        venue: { id: event.venueId },
        store: { id: event.storeId },
        orderItems: partialOrder.orderItems.map(orderItem => ({
            id: orderItem.id,
            product: {
                id: orderItem.product,
                name: orderItem.productName || '',
            },
            status: orderItem.status || domain_1.OrderItemStatus.CREATED,
            taxInclusive: orderItem.taxInclusive,
            quantity: orderItem.quantity || 0,
            unitPrice: orderItem.unitPrice || 0,
            taxes: orderItem.taxes || [],
            costPrice: orderItem.costPrice || 0,
            variant: orderItem.variant
                ? {
                    id: orderItem.variant,
                }
                : null,
            modifiers: orderItem.modifiers || [],
            discounts: orderItem.discounts || [],
            adjustments: orderItem.adjustments || [],
            discountAmount: 0,
            ...(orderItem.notes && { notes: orderItem.notes }),
            printerProfiles: orderItem.printerProfiles || [],
            course: orderItem.course,
        })),
        createdAt: partialOrder.createdAt,
        createdBy: { id: partialOrder.createdBy },
        createdByDevice: { id: partialOrder.createdByDevice },
        orderNumber: partialOrder.orderNumber,
        table: partialOrder.table || null,
        status: partialOrder.status || domain_1.OrderStatus.CREATED,
        payments: partialOrder.payments,
        orderType: { id: partialOrder.orderType },
        salesChannel: { id: partialOrder.salesChannel },
        ...(((_a = partialOrder.customer) === null || _a === void 0 ? void 0 : _a.id) && { customer: partialOrder.customer }),
        taxes: partialOrder.taxes,
        discounts: partialOrder.discounts,
        adjustments: partialOrder.adjustments || [],
        discountAmount: 0,
        totalPrice: 0,
        totalPaymentAmount: 0,
        totalTax: 0,
        subTotal: 0,
        deliveryFee: partialOrder.deliveryFee || 0,
        serviceCharge: partialOrder.serviceCharge || 0,
        tip: partialOrder.tip || 0,
        ...(partialOrder.orderName && { orderName: partialOrder.orderName }),
        ...(partialOrder.orderNote && { orderNote: partialOrder.orderNote }),
        ...(partialOrder.table && {
            table: partialOrder.table,
            tables: [partialOrder.table],
        }),
        integrationInfo: partialOrder.integrationInfo,
        ...(partialOrder.requiredAt && { requiredAt: partialOrder.requiredAt }),
        ...(partialOrder.courier && { courier: partialOrder.courier }),
        ...(partialOrder.shippingAddress && {
            shippingAddress: partialOrder.shippingAddress,
        }),
        dueAt: partialOrder.dueAt,
        prepTime: partialOrder.prepTime,
    };
    // Calculating order item discount separately
    order.orderItems.forEach(orderItem => {
        orderItem.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(orderItem);
    });
    if (event.source) {
        order.source = event.source;
    }
    order = { ...order, ...(0, computePrice_1.computeOrderTotals)(order) };
    return order;
}
exports.default = default_1;
//# sourceMappingURL=initiateOnlineOrder.js.map